'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('./../../helper/graphicsHelper');
var convertHelper = require('../../types/convertHelper');
var dataHelper = require('../../helper/dataHelper');
var tableHelper = require('../../helper/tableHelper');
var util = require('../../helper/util');

var NewTable = React.createClass({
  propTypes: {},

  getInitialState: function () {
    var cols = JSON.parse(JSON.stringify(this.props.cols.col));
    var rows = JSON.parse(JSON.stringify(this.props.rows.row));
    var cells = JSON.parse(JSON.stringify(this.props.cells.cell));

    var coords = tableHelper.buildCoords(rows, cols);
    var matrix = tableHelper.buildMatrix(rows, cols, cells);
    var cell;
    //应用交错、表头风格属性
    for (var i = 0; i < matrix.length; i++) {
      for (var j = 0; j < matrix[i].length; j++) {
        cell = matrix[i][j];
        if(this.props.tableStyle !== undefined && cell.backColor === '#FFFFFF') {
          if(this.props.tableStyle === 'tsInterlace' && i % 2 !== 0) {
            cell.backColor = '#EEEEEE';
          }
          if(this.props.tableStyle === 'tsTitle' && i === 0) {
            cell.backColor = '#999999';
          }
        }
      }
    }
    return {
      coords: coords,
      matrix: matrix
    };
  },

  render: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var elWidth, elHeight;
    var canvasStyle = {
      position: 'absolute',
      left: 0,
      top: 0,
      width: w,
      height: h
    };
    if (window.devicePixelRatio) {
      elWidth = w * window.devicePixelRatio;
      elHeight = h * window.devicePixelRatio;
    } else {
      elWidth = w;
      elHeight = h;
    }
    return (
      <div>
        <div className="cells">
          {this.renderCells()}
        </div>
        <canvas style={canvasStyle} width={elWidth} height={elHeight} ref="canvas"/>
      </div>
    );
  },

  renderCells: function () {
    var cellList = [];
    var areaStyle, horiStyle, fontStyle;
    var area, cell, text;
    var cells = tableHelper.getAllCells(this.state.matrix, this.state.coords);
    for (var i = 0; i < cells.length; i++) {
      cell = cells[i];
      area = cell.area;
      text = cell.text;
      if (typeof text !== 'string') {
        text = ' ';
      }
      areaStyle = {
        position: 'absolute',
        left: area.left,
        top: area.top,
        width: area.width,
        height: area.height,
        backgroundColor: cell.backColor,
      };
      fontStyle = {
        margin: '5px',
        height: area.height - 10,
        width: area.width - 10,
        overflow: 'hidden',
        color: cell.textColor,
        fontSize: cell.fontSize,
        fontFamily: dataHelper.decodeURIComponent(cell.font.family.replace(/\+/g, '%20')),
        fontWeight: cell.textStyles.fontWeight,
        fontStyle: cell.textStyles.fontStyle,
        textDecoration: cell.textStyles.textDecoration,
        textAlign: convertHelper.getTextHorizontalAlign(cell.textHAlign),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: convertHelper.getFlexVerticalAlign(cell.textVAlign)
      };

      if (!cell.textWordWrap) {
        fontStyle.whiteSpace = 'nowrap';
      } else {
        fontStyle.wordWrap = 'breake-word';
      }

      styleHelper.StyleUtil(cell, fontStyle).align().text().background();
      var textArray = text.split('\n');
      cellList.push(
        <div style={areaStyle} key={i}>
            <div className="texts" style={fontStyle}>
              {textArray.map(function (txt, idx) {
                if (!txt.trim()) {
                  return <p key={idx}></p>;
                }
                return <p key={idx}>{txt}</p>;
              })}
            </div>
        </div>
      );

    }
    return cellList;
  },

  componentDidMount: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var context = canvas.getContext('2d');
    this.drawLine(context);
  },

  drawLine: function (context) {
    var horiLines = this.getHoriDiliverLine();
    var vertLines = this.getVertDiliverLine();
    var lines = horiLines.concat(vertLines);
    var line;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);

    var borderStyle = {
      thickness: styleHelper.getBorderWidth(this.props),
      dashMode: styleHelper.getPropertyValue(this.props, 'dashMode') || 'solid',
      borderColor: styleHelper.getBorderColor(this.props),
      borderVisible: styleHelper.getBorderVisible(this.props)
    };

    graphicsHelper.drawRect(context, 0, 0, w, h, borderStyle, false);
    if (window.devicePixelRatio) {
      context.scale(window.devicePixelRatio, window.devicePixelRatio);
    }
    for (var i = 0; i < lines.length; i++) {
      line = lines[i];
      if (window.devicePixelRatio) {
        line.lineWidth = line.lineWidth / window.devicePixelRatio;
      }
      graphicsHelper.drawLine(context, line);
    }
  },

  getHoriDiliverLine: function () {
    var horiLines = [];
    var offset = 0;
    var w = styleHelper.getWidth(this.props);
    var borderWidth = styleHelper.getBorderWidth(this.props) || 1;
    var lineWidth;
    var dashMode;
    var strokeColor;
    var aboveCell, bottomCell, topCell;
    if(this.props.tableStyle === 'tsHiddenLine' || this.props.tableStyle === 'tsHiddenRowLine') {
      return horiLines;
    }
    for (var i = 0; i < this.state.matrix.length - 1; i++) {
      for (var j = 0; j < this.state.matrix[0].length; j++) {
        aboveCell = this.state.matrix[i][j];
        bottomCell = this.state.matrix[i+1][j];
        //合并单元格
        if(aboveCell === bottomCell) {
          continue;
        }
        if (bottomCell.editIndex !== undefined && aboveCell.editIndex !== undefined
          && parseInt(bottomCell.editIndex, 10) > parseInt(aboveCell.editIndex, 10)) {
          topCell = bottomCell;
        } else {
          topCell = aboveCell;
        }
        if (topCell.bottomBorderVisible) {
          lineWidth = Math.round(topCell.bottomBorderThinckness);
          dashMode = styleHelper.parseDashMode(topCell.bottomBorderDashMode);
          strokeColor = topCell.bottomBorderColor;
          offset = 0;
          if (lineWidth % 2 !== 0) {
            offset = 0.5;
          }

          var line = {
            startX: Math.round(this.state.coords[i][j].left) + offset,
            endX: Math.round(this.state.coords[i][j].right) + offset,
            startY: Math.round(this.state.coords[i][j].bottom) + offset,
            endY: Math.round(this.state.coords[i][j].bottom) + offset,
            lineWidth: lineWidth,
            strokeColor: strokeColor,
            dashMode: dashMode
          };

          line.startX = Math.max(line.startX, lineWidth / 2 + borderWidth);
          line.endX = Math.min(line.endX, w - borderWidth - lineWidth / 2);

          horiLines.push(line);
        }
      }
    }
    return horiLines;
  },

  getVertDiliverLine: function () {
    var vertLines = [];
    var offset = 0;
    var h = styleHelper.getHeight(this.props);
    var borderWidth = styleHelper.getBorderWidth(this.props) || 1;
    var lineWidth;
    var dashMode;
    var strokeColor;
    var leftCell, rightCell, topCell;
    if(this.props.tableStyle === 'tsHiddenLine' || this.props.tableStyle === 'tsHiddenColLine') {
      return vertLines;
    }
    for (var i = 0; i < this.state.matrix.length; i++) {
      for (var j = 0; j < this.state.matrix[0].length - 1; j++) {
        if (this.state.matrix[i][j].rightBorderVisible) {
          leftCell = this.state.matrix[i][j];
          rightCell = this.state.matrix[i][j+1];
          //合并单元格
          if(leftCell === rightCell) {
            continue;
          }
          if (rightCell.editIndex !== undefined && leftCell.editIndex !== undefined
            && parseInt(rightCell.editIndex, 10) > parseInt(leftCell.editIndex, 10)) {
            topCell = rightCell;
          } else {
            topCell = leftCell;
          }
          lineWidth = Math.round(topCell.rightBorderThinckness);
          dashMode = styleHelper.parseDashMode(topCell.rightBorderDashMode);
          strokeColor = topCell.rightBorderColor;
          offset = 0;
          if (lineWidth % 2 !== 0) {
            offset = 0.5;
          }
          var line = {
            startX: Math.round(this.state.coords[i][j].right) + offset,
            endX: Math.round(this.state.coords[i][j].right) + offset,
            startY: Math.round(this.state.coords[i][j].top) + offset,
            endY: Math.round(this.state.coords[i][j].bottom) + offset,
            lineWidth: lineWidth,
            strokeColor: strokeColor,
            dashMode: dashMode
          };

          line.startY = Math.max(line.startY, lineWidth / 2 + borderWidth);
          line.endY = Math.min(line.endY, h - borderWidth - lineWidth / 2);
          vertLines.push(line);
        }
      }
    }
    return vertLines;
  }
});

module.exports = NewTable;


// WEBPACK FOOTER //
// ./src/views/Components/NewTable.jsx